import {
  ThemeContextProvider,
  Heading_4 as Typography,
} from '@huggg/react-components';
import { PrivateRoute } from 'components';
import { ScrollToTop } from 'components/misc';
import ScheduledMaintenanceBanner from 'components/ui/ScheduledMaintenanceBanner/ScheduledMaintenanceBanner';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { Route, Router, Switch } from 'react-router-dom';
import { getHuggg, isBlueHuggg } from 'redux/modules/huggg';
import HistoryService from 'services/HistoryService';
import { getThemeModelLoader } from 'utilities/getThemeModelLoader';
import ScreenChoose from './Choose/Choose';
import ScreenError from './Error';
import ScreensHugggStashed from './Huggg/Stashed';
import ScreensLanding from './Landing/Landing';
import ScreensLogin from './Login/Login';
import ScreensMoreDetails from './MoreDetails/MoreDetails';
import ScreensMyHugggs from './MyHugggs/MyHugggs';
import ProductPreview from './ProductPreview/ProductPreview';
import ScreensHowToRedeem from './Redeem/HowToRedeem';
import MerchantTerms from './Redeem/MerchantTerms';
import ScreensRedeem from './Redeem/Redeem';
import ScreensRedeemed from './Redeem/Redeemed';
import ScreensTestRedeemed from './Redeem/TestRedeemed';
import ScreensReveal from './Reveal/Reveal';
import ScreensSuperhugggStashed from './Superhuggg/Stashed';
import ScreensUnstashed from './Unstashed/UnstashedContainer';
import styles from './root.module.scss';

const history = new HistoryService();

export const ScreensRoot = ({ huggg, isBlue }) => {
  /* eslint-disable react-hooks/exhaustive-deps */
  const { theme, modelLoader } = useMemo(() => {
    return getThemeModelLoader(huggg?.theme_info);
  }, [huggg?.theme_info]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return (
    <ThemeContextProvider modelLoader={modelLoader} theme={theme}>
      <Typography className={styles.root}>
        <Router history={history}>
          <ScrollToTop>
            {isBlue ? <ScheduledMaintenanceBanner /> : null}

            <Switch>
              <Route path="/error" component={ScreenError} />

              {theme === 'default' && (
                <Route path="/login" component={ScreensLogin} />
              )}

              {/* Product preview route placed early to avoid being shadowed by other routes */}
              <Route path="/products/:productId" component={ProductPreview} />

              <Route
                path="/super/:shortcode/stashed"
                component={ScreensSuperhugggStashed}
              />

              {/* Shared Routes */}
              <Route
                path="/(super|test)?/:shortcode"
                exact
                component={ScreensLanding}
              />
              <Route
                path="/(super|test)?/:shortcode/more-information"
                component={ScreensMoreDetails}
              />
              <Route
                path="/(super|test)?/:shortcode/stash"
                component={ScreensUnstashed}
              />
              <Route
                path="/(super|test)?/:shortcode/(merchant|partner)-terms"
                component={MerchantTerms}
              />

              {/* Regular Huggg Routes */}
              <Route
                path="/(test)?/:shortcode/redeemed"
                component={ScreensRedeemed}
              />
              <Route
                path="/(test)?/:shortcode/reveal"
                component={ScreensReveal}
              />
              <Route
                path="/(test)?/:shortcode/choose"
                component={ScreenChoose}
              />
              <Route
                path="/(test)?/:shortcode/redeem"
                component={ScreensRedeem}
              />
              <Route
                path="/(test)?/:shortcode/stashed"
                component={ScreensHugggStashed}
              />
              <Route
                path="/(test)?/:shortcode/how-to-redeem"
                component={ScreensHowToRedeem}
              />

              <Route
                path="/test/:shortcode/test-redeemed"
                component={ScreensTestRedeemed}
              />

              <PrivateRoute path="/" exact component={ScreensMyHugggs} />
              <Route
                component={() => {
                  return (
                    <ScreenError errorMessage="Sorry, what you're looking for can't be found." />
                  );
                }}
              />
            </Switch>
          </ScrollToTop>
        </Router>
      </Typography>
    </ThemeContextProvider>
  );
};

ScreensRoot.propTypes = {
  huggg: PropTypes.object.isRequired,
  isBlue: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    huggg: getHuggg(state),
    isBlue: isBlueHuggg(state),
  };
};

export default connect(mapStateToProps)(ScreensRoot);
